// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { linkListStyles } from "@awc/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { css } from "styled-components";

linkListStyles.linkListWrapper = {
    css: css`
        padding: 0;
    `,
};
linkListStyles.linksWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 8px;
    `,
};
linkListStyles.titleWrapper = {
    css: css`
        display: flex;
        margin-bottom: 12px;
        &:empty,
        &:has(> :first-child:empty) {
            display: none;
        }
    `,
};

linkListStyles.titleLink = {
    typographyProps: {
        variant: "h4",
        weight: fontConfig.weight.bold,
        lineHeight: "19px",
        css: css`
            text-transform: uppercase;
            letter-spacing: 0;
            margin-bottom: 0;
            && {
                font-size: ${fontConfig.fontSize.singleLineRegular};
            }
        `,
        ...{ as: "h2" },
    },
    css: css`
        &:focus {
            outline: none;
        }
    `,
};

linkListStyles.title = {
    ...linkListStyles.titleLink.typographyProps,
};

linkListStyles.link = {
    typographyProps: {
        size: fontConfig.fontSize.regular,
        weight: fontConfig.weight.regular,
        lineHeight: fontConfig.lineHeight.singleLineRegular,
        css: css`
            text-transform: capitalize;
            letter-spacing: 0;
        `,
    },
};
